/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { ModuleWithProviders, NgModule, Provider } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginService } from './login/login.service';
import { LoginComponent } from './login/login.component';
import { MessageModule } from 'primeng/message';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { EnvironmentModule } from '@irian-ro/shared-components-module';
import * as langs from '../i18n/i18n';
import { TermsAndConditionsRequestService } from './terms-and-conditions/terms-and-conditions-request.service';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { MessagesModule } from 'primeng/messages';
import { MessageService } from 'primeng/api';
import { AuthOptions, UserManagementModule } from '@irian-ro/util-user';
import { PasswordModule } from 'primeng/password';

@NgModule({
  imports: [
    CommonModule,
    MessagesModule,
    MessageModule,
    TranslateModule,
    FormsModule,
    InputTextModule,
    ButtonModule,
    EnvironmentModule,
    PasswordModule],
  declarations: [LoginComponent],
})
export class AuthSharedModule {
  constructor(translateService: TranslateService) {
    Object.keys(langs).map((lang) => {
      translateService.setTranslation(lang, langs[lang], true);
    });
  }

  static forRoot(options?: AuthOptions, loggedInContextProvider?: Provider): ModuleWithProviders<AuthSharedModule> {
    return {
      ngModule: AuthSharedModule,
      providers: [
        UserManagementModule.forRoot(options, loggedInContextProvider).providers,
        LoginService,
        MessageService,
        TermsAndConditionsRequestService
      ],
    };
  }
}
